<!-- 获取停车场车流量情况接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC",
                "startTime":"2017-09-19 00:00:00",
                "endTime":"2017-09-19 00:01:00"
            },
            responseCode: {
                "data": {
                    "parkCode": "2KNTYVWC",
                    "trafficList": [
                        {
                            "carInNum": 0,
                            "carOutNum": 0,
                            "time": "2016-09-19 00:00"
                        }
                    ]
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取单个停车场每分钟车流量情况",
                t_url: this.commonUrls.test+"getTrafficFlow",
                p_url: this.commonUrls.prod+"getTrafficFlow",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '开始时间，yyyy-MM-dd HH:mm' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyy-MM-dd HH:mm。开始与结束时间间隔不允许超过一天' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'trafficList', info2: '是', info3: 'JSONArray', info4: '每分钟车流量' }
                        ]
                },{
                    titleName: 'trafficList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'time', info2: '是', info3: 'String', info4: '时间yyyy-MM-dd HH:mm' },
                        { info1: 'carInNum', info2: '是', info3: 'Integer', info4: '进场总数' },
                        { info1: 'carOutNum', info2: '是', info3: 'Integer', info4: '出场总数' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/dataAnalysis/getTrafficFlow.vue